module.exports = __webpack_public_path__ + "img/210461.7f0cdc9b.svg";